import {
  OrganizationBreakdownClient,
  ClientOutput,
} from '../../Clients/OrganizationBreakdownClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/Dashboard/OrganizationBreakdown';

export const organizationBreakdownClient = new OrganizationBreakdownClient(
  new ApiGetter()
);

interface GetOrganizationBreakdownAction {
  organizationUUID: string;
}

export function* getOrganizationBreakdown({
  organizationUUID,
}: GetOrganizationBreakdownAction) {
  const cumulative: ClientOutput = yield call(
    [organizationBreakdownClient, organizationBreakdownClient.retrieveAsync],
    organizationUUID
  );

  const currentPeriod: ClientOutput = yield call(
    [organizationBreakdownClient, organizationBreakdownClient.retrieveAsync],
    organizationUUID,
    true
  );

  yield put(
    actions.setData({
      cumulative: cumulative.error ? undefined : cumulative.data,
      currentPeriod: currentPeriod.error ? undefined : currentPeriod.data,
    })
  );
}
